module.exports = __webpack_public_path__ + "img/app9.a28c5828.png";